/* =========================================================
   PROSPECT — Theme JS
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* =========================================================
     OVERLAY / PAGE SCROLL LOCK
     ========================================================= */

  var scrollLockCount = 0;

  function lockPageScroll() {
    scrollLockCount += 1;

    if (scrollLockCount === 1) {
      document.documentElement.classList.add('overlay-open');
      document.body.classList.add('overlay-open');
    }
  }

  function unlockPageScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);

    if (scrollLockCount === 0) {
      document.documentElement.classList.remove('overlay-open');
      document.body.classList.remove('overlay-open');
    }
  }

  /* =========================================================
     DIALOG FOCUS MANAGEMENT (R14)
     Trap Tab inside the open dialog; return focus to the
     opener on close.
     ========================================================= */

  var activeDialog = null;

  function trapDialogFocus(dialog) {
    activeDialog = { dialog: dialog, opener: document.activeElement };

    var first = dialog.querySelector(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );

    if (first) {
      first.focus();
    }
  }

  function releaseDialogFocus() {
    if (activeDialog && activeDialog.opener && document.contains(activeDialog.opener)) {
      activeDialog.opener.focus();
    }

    activeDialog = null;
  }

  document.addEventListener('keydown', function (e) {
    if (!activeDialog || e.key !== 'Tab') return;

    var dialog = activeDialog.dialog;

    var nodes = dialog.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );

    var focusables = Array.prototype.filter.call(nodes, function (el) {
      return el.offsetParent !== null;
    });

    if (!focusables.length) {
      e.preventDefault();
      return;
    }

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });


  /* =========================================================
     MOBILE MENU
     ========================================================= */

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  var header = document.querySelector('.site-header');

  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');

      menuToggle.setAttribute('aria-expanded', open);

      if (header) {
        header.classList.toggle('menu-open', open);
      }
    });

    nav.querySelectorAll('li').forEach(function (li) {
      var link = li.querySelector('a');
      var submenu = li.querySelector('.site-header__submenu');

      if (submenu && link && window.innerWidth <= 900) {
        link.addEventListener('click', function (e) {
          if (!li.classList.contains('is-expanded')) {
            e.preventDefault();
            li.classList.add('is-expanded');
          }
        });
      }
    });
  }


  /* =========================================================
     SCROLL ANIMATIONS
     ========================================================= */

  var animated = document.querySelectorAll('[data-animate]');

  if ('IntersectionObserver' in window && animated.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15
    });

    animated.forEach(function (el) {
      io.observe(el);
    });
  } else {
    animated.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }


  /* =========================================================
     SLIDESHOW
     ========================================================= */

  document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
    var slides = slideshow.querySelectorAll('.slideshow__slide');
    var dots = slideshow.querySelectorAll('.slideshow__dot');
    var current = 0;
    var autoplay = slideshow.dataset.autoplay === 'true';
    var interval = parseInt(slideshow.dataset.interval || '5000', 10);

    function show(index) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });

      current = index;
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        show(index);
      });
    });

    if (autoplay && slides.length > 1) {
      setInterval(function () {
        show((current + 1) % slides.length);
      }, interval);
    }
  });


  /* =========================================================
     COUNTDOWN TIMERS
     ========================================================= */

  // Parse a countdown target. A value with an explicit offset (or Z) is
  // honored as given; a bare "YYYY-MM-DDTHH:MM:SS" is interpreted as
  // America/New_York wall time (DST-aware via Intl).
  function countdownTarget(raw) {
    raw = (raw || '').trim();
    if (/([+-]\d{2}:?\d{2}|Z)$/i.test(raw)) return new Date(raw).getTime();
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (!m) return new Date(raw).getTime();
    var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    function wallOf(t) {
      var p = {};
      fmt.formatToParts(new Date(t)).forEach(function (x) { p[x.type] = x.value; });
      return Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second);
    }
    var guess = wall;
    for (var i = 0; i < 4; i++) guess += (wall - wallOf(guess));
    return guess;
  }

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = countdownTarget(el.dataset.countdown);
    var daysEl = el.querySelector('[data-cd-days]');
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minsEl = el.querySelector('[data-cd-mins]');
    var secsEl = el.querySelector('[data-cd-secs]');

    function tick() {
      var diff = target - Date.now();

      if (diff <= 0) {
        el.style.display = 'none';
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(mins).padStart(2, '0');
      if (secsEl) secsEl.textContent = String(secs).padStart(2, '0');
    }

    tick();
    setInterval(tick, 1000);
  });


  /* =========================================================
     STICKY HEADER
     ========================================================= */

  window.addEventListener('scroll', function () {
    if (!header) return;

    header.classList.toggle('is-scrolled', window.scrollY > 40);
  }, {
    passive: true
  });


  /* =========================================================
     CART DRAWER + AJAX CART
     ========================================================= */

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartIsOpen = false;

  function openCartDrawer() {
    if (!cartDrawer || cartIsOpen) return;

    cartIsOpen = true;

    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');

    if (cartOverlay) {
      cartOverlay.classList.add('is-open');
    }

    lockPageScroll();
    trapDialogFocus(cartDrawer);
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartIsOpen) return;

    cartIsOpen = false;

    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');

    if (cartOverlay) {
      cartOverlay.classList.remove('is-open');
    }

    unlockPageScroll();
    releaseDialogFocus();
  }

document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
  btn.addEventListener('click', function (e) {
    e.preventDefault();

    openCartDrawer();
  });
});

  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  function refreshCartDrawer() {
    return fetch('/cart?view=drawer')
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Could not load cart drawer.');
        }

        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var fresh = doc.querySelector('[data-cart-drawer-content]');
        var target = document.querySelector('[data-cart-drawer-content]');

        if (fresh && target) {
          target.innerHTML = fresh.innerHTML;
          target.scrollTop = 0;
        }
      })
      .catch(function (err) {
        console.error('Could not refresh cart drawer.', err);
      });
  }

  function refreshMainCart() {
    var mainCart = document.querySelector('[data-main-cart]');

    if (!mainCart) {
      return Promise.resolve();
    }

    return fetch('/cart')
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Could not load cart.');
        }

        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-main-cart]');

        if (fresh && mainCart) {
          mainCart.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function (err) {
        console.error('Could not refresh main cart.', err);
      });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }


  /* ---------- Add to cart ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');

    if (!form) return;

    e.preventDefault();

    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Could not add to cart.');
        }

        return res.json();
      })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Could not load cart.');
        }

        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        openCartDrawer();

        return refreshCartDrawer();
      })
      .catch(function (err) {
        console.error('Could not add to cart.', err);
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText || 'Add to Bag';
        }
      });
  });


  /* ---------- Cart note autosave ---------- */

  document.addEventListener('focusout', function (e) {
    var note = e.target.closest('[data-cart-note]');

    if (!note) return;

    var noteWrap = note.closest('.cart-drawer__note-wrap');
    var status = noteWrap
      ? noteWrap.querySelector('[data-cart-note-status]')
      : null;

    if (status) {
      status.textContent = 'Saving…';
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        note: note.value
      })
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Could not save note.');
        }

        return res.json();
      })
      .then(function () {
        if (status) {
          status.textContent = 'Note saved';
        }

        refreshMainCart();

        setTimeout(function () {
          if (status && status.textContent === 'Note saved') {
            status.textContent = '';
          }
        }, 2000);
      })
      .catch(function () {
        if (status) {
          status.textContent = 'Could not save note';
        }
      });
  });


  /* ---------- Cart quantity / remove ---------- */

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-line-remove]');

    if (minus || plus) {
      var control = minus || plus;
      var line = control.closest('[data-cart-line]');

      if (!line) return;

      var input = line.querySelector('input[type="number"]');

      if (!input) return;

      var value = parseInt(input.value, 10) || 0;

      value = minus
        ? Math.max(0, value - 1)
        : value + 1;

      updateLine(line.dataset.lineKey, value);
      return;
    }

    if (remove) {
      var removeLine = remove.closest('[data-cart-line]');

      if (!removeLine) return;

      updateLine(removeLine.dataset.lineKey, 0);
    }
  });

  function updateLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Cart update failed.');
        }

        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);

        return Promise.all([
          refreshCartDrawer(),
          refreshMainCart()
        ]);
      })
      .catch(function (err) {
        console.error('Could not update cart.', err);
      });
  }


  /* =========================================================
     SEARCH MODAL + PREDICTIVE SEARCH
     ========================================================= */

  var searchModal = document.querySelector('[data-search-modal]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchIsOpen = false;

  function openSearch() {
    if (!searchModal || searchIsOpen) return;

    searchIsOpen = true;

    searchModal.classList.add('is-open');

    if (searchOverlay) {
      searchOverlay.classList.add('is-open');
    }

    lockPageScroll();
    trapDialogFocus(searchModal);

    var input = searchModal.querySelector('input[type="search"]');

    if (input) {
      window.setTimeout(function () {
        input.focus();
      }, 100);
    }
  }

  function closeSearch() {
    if (!searchIsOpen) return;

    searchIsOpen = false;

    if (searchModal) {
      searchModal.classList.remove('is-open');
    }

    if (searchOverlay) {
      searchOverlay.classList.remove('is-open');
    }

    unlockPageScroll();
    releaseDialogFocus();
  }

  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  });

  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', closeSearch);
  });

  if (searchOverlay) {
    searchOverlay.addEventListener('click', closeSearch);
  }

  var searchInput = document.querySelector('[data-predictive-search-input]');
  var searchResults = document.querySelector('[data-predictive-search-results]');
  var searchTimer;

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);

      var query = searchInput.value.trim();

      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }

      searchTimer = setTimeout(function () {
        fetch(
          '/search/suggest.json?q=' +
          encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6'
        )
          .then(function (res) {
            if (!res.ok) {
              throw new Error('Predictive search failed.');
            }

            return res.json();
          })
          .then(function (data) {
            var products =
              (
                data.resources &&
                data.resources.results &&
                data.resources.results.products
              ) || [];

            if (!products.length) {
              searchResults.innerHTML =
                '<div class="search-modal__empty">' +
                  '<span class="search-modal__empty-label">NO RESULTS</span>' +
                  '<p>Nothing found for &ldquo;' + query + '&rdquo;.</p>' +
                  '<a href="/collections/all" class="search-modal__empty-link">EXPLORE SHOP ALL →</a>' +
                '</div>';

              return;
            }

            searchResults.innerHTML = products.map(function (product) {
              return (
                '<a class="search-result" href="' + product.url + '">' +
                  (
                    product.image
                      ? '<img src="' + product.image + '" alt="">'
                      : ''
                  ) +
                  '<span>' +
                    '<span class="search-result__title">' + product.title + '</span><br>' +
                    '<span class="search-result__price">' + product.price + '</span>' +
                  '</span>' +
                '</a>'
              );
            }).join('');
          })
          .catch(function (err) {
            console.error('Predictive search failed.', err);
          });
      }, 250);
    });
  }


  /* =========================================================
     SIZE CHART MODAL
     ========================================================= */

  var sizeChart = document.querySelector('[data-size-chart]');
  var sizeChartOverlay = document.querySelector('[data-size-chart-overlay]');
  var sizeChartIsOpen = false;

  function openSizeChart() {
    if (!sizeChart || sizeChartIsOpen) return;

    sizeChartIsOpen = true;

    sizeChart.classList.add('is-open');

    if (sizeChartOverlay) {
      sizeChartOverlay.classList.add('is-open');
    }

    lockPageScroll();
    trapDialogFocus(sizeChart);
  }

  function closeSizeChart() {
    if (!sizeChart || !sizeChartIsOpen) return;

    sizeChartIsOpen = false;

    sizeChart.classList.remove('is-open');

    if (sizeChartOverlay) {
      sizeChartOverlay.classList.remove('is-open');
    }

    unlockPageScroll();
    releaseDialogFocus();
  }

  document.querySelectorAll('[data-size-chart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSizeChart();
    });
  });

  document.querySelectorAll('[data-size-chart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeSizeChart);
  });

  if (sizeChartOverlay) {
    sizeChartOverlay.addEventListener('click', closeSizeChart);
  }


  /* =========================================================
     ESCAPE KEY
     ========================================================= */

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    if (sizeChartIsOpen) {
      closeSizeChart();
      return;
    }

    if (searchIsOpen) {
      closeSearch();
      return;
    }

    if (cartIsOpen) {
      closeCartDrawer();
    }
  });


  /* =========================================================
     PROMO POPUP
     ========================================================= */

  var popup = document.querySelector('[data-promo-popup]');

  if (popup && !sessionStorage.getItem('prospectPopupSeen')) {
    var delay = parseInt(popup.dataset.delay || '4000', 10);

    setTimeout(function () {
      popup.classList.add('is-open');

      var popupOverlay = document.querySelector(
        '[data-promo-popup-overlay]'
      );

      if (popupOverlay) {
        popupOverlay.classList.add('is-open');
      }

      sessionStorage.setItem('prospectPopupSeen', '1');
    }, delay);
  }

  document.querySelectorAll('[data-promo-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (popup) {
        popup.classList.remove('is-open');
      }

      var popupOverlay = document.querySelector(
        '[data-promo-popup-overlay]'
      );

      if (popupOverlay) {
        popupOverlay.classList.remove('is-open');
      }
    });
  });


  /* =========================================================
     PRODUCT GALLERY
     ========================================================= */

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaHtml = thumb.dataset.mediaHtml;

        if (mediaHtml && main) {
          main.innerHTML = mediaHtml;
        }

        thumbs.forEach(function (item) {
          item.classList.remove('is-active');
        });

        thumb.classList.add('is-active');
      });
    });

    if (main) {
      main.addEventListener('click', function () {
        main.classList.toggle('is-zoomed');
      });
    }
  });


  /* =========================================================
     BEFORE / AFTER SLIDER
     ========================================================= */

  document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
    var after = slider.querySelector('.ba-slider__after');
    var handle = slider.querySelector('.ba-slider__handle');

    if (!after || !handle) return;

    var dragging = false;

    function setPos(clientX) {
      var rect = slider.getBoundingClientRect();

      var pct = Math.min(
        100,
        Math.max(
          0,
          ((clientX - rect.left) / rect.width) * 100
        )
      );

      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    handle.addEventListener('mousedown', function () {
      dragging = true;
    });

    window.addEventListener('mouseup', function () {
      dragging = false;
    });

    window.addEventListener('mousemove', function (e) {
      if (dragging) {
        setPos(e.clientX);
      }
    });

    slider.addEventListener('touchmove', function (e) {
      if (e.touches && e.touches[0]) {
        setPos(e.touches[0].clientX);
      }
    }, {
      passive: true
    });
  });


  /* =========================================================
     VARIANT PICKER
     ========================================================= */

  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var variantsJson = picker.querySelector('[data-variants-json]');

    if (!variantsJson) return;

    var variants;

    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (err) {
      return;
    }

    var inputs = picker.querySelectorAll('input[name^="option"]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = document.querySelector('[data-add-to-cart]');
    var stockEl = document.querySelector('[data-stock-counter]');
    var form = picker.closest('form');
    var idField = form
      ? form.querySelector('input[name="id"]')
      : null;

    function currentSelection() {
      var groups = {};

      inputs.forEach(function (input) {
        if (input.checked) {
          groups[input.name] = input.value;
        }
      });

      return groups;
    }

    function findVariant() {
      var groups = currentSelection();
      var optionNames = [];

      inputs.forEach(function (input) {
        if (!optionNames.includes(input.name)) {
          optionNames.push(input.name);
        }
      });

      if (Object.keys(groups).length !== optionNames.length) {
        return null;
      }

      return variants.find(function (variant) {
        return optionNames.every(function (name, index) {
          return variant.options[index] === groups[name];
        });
      });
    }

    function render() {
      var variant = findVariant();

      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Select Size';
        }

        return;
      }

      if (idField) {
        idField.value = variant.id;
      }

      if (priceEl) {
        priceEl.textContent = variant.price;
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;

        addBtn.textContent = variant.available
          ? (variant.preorder ? 'Pre-order' : 'Add to Bag')
          : 'Sold Out';
      }

      if (stockEl) {
        if (
          variant.inventory_quantity != null &&
          variant.inventory_quantity <= 5 &&
          variant.inventory_quantity > 0
        ) {
          stockEl.textContent =
            'Only ' +
            variant.inventory_quantity +
            ' left in stock';

          stockEl.style.display = '';
        } else {
          stockEl.style.display = 'none';
        }
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', render);
    });

    render();
  });


  /* =========================================================
     PRODUCT QUANTITY STEPPER
     ========================================================= */

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-step-minus]');
    var plus = e.target.closest('[data-qty-step-plus]');

    if (!minus && !plus) return;

    var control = minus || plus;
    var wrap = control.closest('.product-form__quantity');

    if (!wrap) return;

    var input = wrap.querySelector('input');

    if (!input) return;

    var value = parseInt(input.value, 10) || 1;

    input.value = minus
      ? Math.max(1, value - 1)
      : value + 1;
  });


  /* =========================================================
     RECENTLY VIEWED
     ========================================================= */

  var currentProduct = document.querySelector('[data-current-product]');

  if (currentProduct) {
    var currentHandle = currentProduct.dataset.currentProduct;

    try {
      var viewed = JSON.parse(
        localStorage.getItem('prospectRecentlyViewed') || '[]'
      );

      viewed = viewed.filter(function (handle) {
        return handle !== currentHandle;
      });

      viewed.unshift(currentHandle);
      viewed = viewed.slice(0, 8);

      localStorage.setItem(
        'prospectRecentlyViewed',
        JSON.stringify(viewed)
      );
    } catch (err) {
      /* Storage unavailable */
    }
  }

  var recentlyViewedEl = document.querySelector('[data-recently-viewed]');

  if (recentlyViewedEl) {
    try {
      var stored = JSON.parse(
        localStorage.getItem('prospectRecentlyViewed') || '[]'
      );

      stored = stored.filter(function (handle) {
        return handle !== (
          currentProduct &&
          currentProduct.dataset.currentProduct
        );
      }).slice(0, 4);

      if (!stored.length) {
        recentlyViewedEl.style.display = 'none';
      } else {
        recentlyViewedEl.dataset.handles = stored.join(',');

        recentlyViewedEl.dispatchEvent(
          new CustomEvent('prospect:recently-viewed-ready', { bubbles: true })
        );
      }
    } catch (err) {
      recentlyViewedEl.style.display = 'none';
    }
  }

});